<template>
  <div
    id="feedforwardList"
    :class="['mobile', 'tablet'].includes($mq) ? 'mobileMode' : 'deskMode'"
  >
    <div
      v-if="feedforwardsCount > 0"
      class="data"
    >
      <div v-if="$mq === 'laptop' || $mq === 'desktop'">
        <div
          v-for="(group, key) in sortedFeedforward"
          :key="key"
          class="feedforwardGroup deskGroup"
        >
          <div class="title defaultCursor">
            <div class="groupTitle">
              {{ $t(`session.${key}`) }}
            </div>
            <div class="dateTitle">
              {{ $t('feedforwardGroup.dateReceived') }}
            </div>
          </div>

          <div class="feedforwards defaultCursor">
            <el-row
              v-for="(feedforward, fKey) in group"
              :key="fKey"
              class="feedforwardLine"
              type="flex"
              :gutter="20"
            >
              <el-col
                :span="4"
                class="name"
              >
                {{ feedforward.supporter }}
              </el-col>
              <el-col
                :span="17"
                class="content"
              >
                <el-card
                  shadow="hover"
                  class="clear-card"
                  :body-style="{padding: '10px'}"
                >
                  {{ feedforward.suggestion }}
                </el-card>
              </el-col>
              <el-col
                :span="3"
                class="date"
              >
                {{ feedforward.created_at.split(' ')[0] }}
              </el-col>
            </el-row>
          </div>
        </div>
      </div>

      <div v-else>
        <div
          v-for="(group, key) in feedforwards"
          :key="key"
          class="feedforwardGroup mobileGroup"
        >
          <div class="feedforwards">
            <el-row
              v-for="(feedforward, fKey) in group"
              :key="fKey"
              class="feedforwardLine"
              type="flex"
              :gutter="20"
            >
              <el-col
                :span="24"
                class="content"
              >
                <el-card
                  shadow="hover"
                  class="clear-card"
                  :body-style="{padding: '10px'}"
                >
                  <div class="feedTitle">
                    <b>{{ feedforward.supporter }}</b>
                  </div>
                  {{ feedforward.suggestion }}
                </el-card>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      class="noData"
      :class="['mobile', 'tablet'].includes($mq) ? 'mobileMode' : 'deskMode'"
    >
      No data to display
    </div>
  </div>
</template>

<script>
export default {
  props: {
    feedforwards: {
      type: Object,
      default: null,
    },
  },

  computed: {
    feedforwardsCount() {
      if (!this.feedforwards) return 0;

      const count = Object.values(this.feedforwards).reduce(
        (accumulator, currentValue) => accumulator + currentValue.length,
        0,
      );
      return count;
    },

    sortedFeedforward() {
      const feed = {};

      if (this.feedforwards) {
        Object.keys(this.feedforwards).sort().reverse().forEach((key) => {
          feed[key] = (this.feedforwards[key]);
        });
      }

      return feed;
    },
  },
};
</script>

<style lang="scss" scoped>
#feedforwardList {
  text-align: left;
  padding: 10px;

  &.mobileMode {
    padding: 10px 0;
  }

  .data {
    .feedforwardGroup {
      margin-bottom: 45px;

      &:last-child {
        margin-bottom: 0;
      }

      &.mobileGroup {
        margin-bottom: 0;
      }

      .title {
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        font-weight: bold;
        margin-bottom: 15px;

        .dateTitle {
          font-size: 14px;
        }
      }

      .feedforwards {
        .feedforwardLine {
          margin-bottom: 15px;
          align-items: center;

          .feedTitle {
            padding: 0 0 10px;
          }

          .date {
            text-align: right;
            font-style: italic;
            font-size: 12px;
          }
        }
      }
    }
  }

  .noData {
    text-align: center;
    min-height: 400px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-style: italic;

    &.mobileMode {
      background: var(--themeCardColor);
      border-radius: 10px;
      color: var(--themeFontColor);
    }
  }
}
</style>
